module.exports = __webpack_public_path__ + "prod/1.42.2/img/yycj_bg.e1af95c6.jpg";